import styled from 'styled-components'
import Colors from '../../../theme/colors'
import Text from '../../../atoms/Text/Text'
import Heading from '../../../atoms/Heading/Heading'

export const PriceListItem = styled.div<{
  highlight: boolean
}>`
  display: flex;
  justify-content: space-between;
  padding: 12px;

  ${({ highlight }) =>
    highlight &&
    `
      border-radius: 4px;
      background-color: ${Colors.Secondary.purple600};

      ${Text}, ${Heading} {
        color: ${Colors.Primary.White};
      }
    `}
`
